
import Vue from 'vue';
import isMobileView from '@root/common/utils/isMobileView';
import { PodcastCategory } from '@root/modules/podcast/types/podcast';
import Radio from '@root/modules/podcast/components/fragments/Radio.vue';

interface Props {
  category: PodcastCategory;
}

interface Data {
  isMobileView: boolean;
}

interface Methods {
  loadMoreCategories: () => void;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    Radio,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMobileView: false,
    };
  },
  mounted() {
    this.isMobileView = isMobileView();
  },
});
